
import React, { Component } from 'react'
import './Company.css'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import { Config } from '../../Config'
import { CommonConstants } from '../../Constants'
import Api from '../../Api'
import 'react-confirm-alert/src/react-confirm-alert.css'
import 'url-search-params-polyfill'
import AuthenticationService from '../Security/AuthenticationService'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getCompanyDetail } from '../../actions/company'
import { getCountryList } from '../../actions/country'
import { getDistributorList } from '../../actions/distributor'
import { getRegionList } from '../../actions/region'
import CommonLoader from '../Alerts/CommonLoader'
import CommonFunctions from '../../components/Common/Functions'
import { PopulateError } from '../Common/PopulateError'
import { CountryOptions } from '../Common/Country'
import Region from '../Common/Region'
// Company - Component

class Company extends Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      isvalid: true,
      successMessage: '',
      errorMessage: [],
      saveSuccess: props.saveSuccess,
      countries: [],
      regions: [],
      distributor: [],
      companydetails: {},
      selectedCountry: null,
      regioncalled: false,
      showLoader: false
    }
    this.api = new Api()
    this.commonFunctions = new CommonFunctions()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    let isAdmin = this.authService.isAdmin()
    this.state.isAdmin = isAdmin
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  // While change the country dropdown box and get the current value
  countryChange (event) {
    this.updateRegion(event.target.value)
  }

  // based on the countryID set the region list
  updateRegion (countryID) {
    this.props.getRegionList(countryID)
  }

  // Before submit check input validation and if any errors comes throw the particular error
  handleValidation () {
    var rezip = new RegExp(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/)
    var rephone = new RegExp(/[0-9]{3}/)
    const language = this.state.language
    let company = this.state.companydetails
    let errors = []
    if (company.companyName === '') {
      errors.push(t[language].companyblank)
    }
    if (company.addressLine1 === '') {
      errors.push(t[language].companyaddressblank)
    }
    if (company.city === '') {
      errors.push(t[language].companycityblank)
    }
    if (company.state === 'select' || company.state === '') {
      errors.push(t[language].blankstate)
    }
    if (company.countryId === 1 && !rezip.test(company.zipcode)) {
      errors.push(t[language].zipcodeinvalid)
    } else if (company.zipcode === '') {
      errors.push(t[language].zipcodeblank)
    }

    if (company.phoneNumber === '' || !rephone.test(company.phoneNumber)) {
      errors.push(t[language].companyphoneblank)
    }
    this.setState({ errorMessage: errors })
    if (errors.length > 0) {
      this.setState({ isvalid: false })
      return false
    }
    this.setState({ isvalid: true })
    return true
  }

  // Input onchange function
  handleChange (event) {
    let { name, value } = event.target
    let companydetails = this.state.companydetails
    if (name === 'countryId') {
      companydetails.state = ''
      this.updateRegion(event.target.value)
    }
    companydetails[name] = value
    this.setState({ companydetails })
  }

  // submit function
  handleSubmit () {
    if (this.handleValidation()) {
      this.setState({ showLoader: true })
      let url = Config.apiBaseUrl + CommonConstants.apiUrls.saveCompany
      const data = this.state.companydetails
      // Post the current input state using API call
      this.api.postData(url, data, (result) => {
        if (result.status) {
          this.setState({ saveSuccess: true, successMessage: t[this.state.language].recordsaved })
          this.props.onSaveSuccess()
          this.setState({ showLoader: false })
        }
      })
    }
  }
  // Using React lifescycle method and set the default state
  componentWillMount () {
    let TOSAgree = this.authService.getProfile().Account_TOS_Agree
    if (TOSAgree === 0 || TOSAgree === null) {
      window.location.href = '/myAccount'
    }
  }
  // Using React lifescycle method and call all inside function after page load
  componentDidMount () {
    this.props.getCompanyDetail()
    this.props.getDistributorList()
    this.props.getCountryList()
    this.state.regioncalled = false
  }

  // Using React lifescycle method and check the compare the state before page load
  componentWillReceiveProps (nextProps) {
    if (nextProps.companyDetails.countryId > 0 && !this.state.regioncalled) {
      this.updateRegion(nextProps.companyDetails.countryId)
      this.state.regioncalled = true
    }
  }

  // Main Render function
  render () {
    const showLoader = this.state.showLoader
    const language = this.state.language
    let companydetail = {}
    if (this.props.companyDetails != null) {
      this.state.companydetails = this.props.companyDetails
      companydetail = this.props.companyDetails
    }

    // Displaying distributorlist
    const distributorlist = (datalist, selectedvalue = 0) => {
      return datalist.map(item => {
        if (selectedvalue === item.Company_ID) {
          return <option value={item.Company_ID} selected={selectedvalue === item.Company_ID} >{item.Company_Name}</option>
        } else {
          return <option value={item.Company_ID}>{item.Company_Name}</option>
        }
      })
    }
   
    
    // before showing company deatils check the company deatils is not null
    if (this.props.companyDetails == null) {
      return <div />
    } else {
      return (
        <section className='myaccount'>
          <div className={showLoader ? 'show' : 'hide'}>
            {/* Page Loader function */}
            <CommonLoader showLoader={showLoader} message={t[language].settingsStoresLoadingMessage1} language={language} />
          </div>
          <div className={this.props.saveSuccess && !showLoader ? 'show' : 'hide'}>
            <div className='forms clear'>
              <div className='appr' >
                <h4 translate='' key='recordsaved'>{this.state.successMessage}</h4>
              </div>
            </div>
          </div>
          <section className={'report-container ' + (this.props.saveSuccess || showLoader ? 'hide' : 'show')}>
            <div className='company-info forms clear'>
              <h1>{t[language].companyinfo}</h1>
              <div className='status-messages'>
                <div className={'alert alert-danger errors ' + (this.state.isvalid ? 'hide' : 'show')} >
                  <ul> <PopulateError errors={this.state.errorMessage} /></ul>
                </div>
              </div>
              <div className='acctinfo clear'>
                <form >
                  <table className='company_form'>
                    <tbody>
                      <tr>
                        <th className='req'><label htmlFor='companyName' translate='' key='companyname'>{t[language].companyname}</label></th>
                        <td><input type='text' maxLength='100' name='companyName' value={companydetail.companyName} onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''} /></td>
                      </tr>

                      <tr>
                        <th><label htmlFor='companyAvanteCustId'>{t[language].hmeAvante}</label></th>
                        <td><input type='text' maxLength='100' name='companyAvanteCustId' value={companydetail.companyAvanteCustId} onChange={this.handleChange} disabled='disabled' /></td>
                      </tr>

                      <tr>
                        <th className='req'><label htmlFor='addressLine1' translate='' key='address1'>{t[language].address1}</label></th>
                        <td><input type='text' maxLength='100' name='addressLine1' value={companydetail.addressLine1} onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''} /></td>
                      </tr>

                      <tr>
                        <th><label htmlFor='addressLine2' translate='' key='address2'>{t[language].address2}</label></th>
                        <td><input type='text' maxLength='100' name='addressLine2' value={companydetail.addressLine2} onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''} /></td>
                      </tr>

                      <tr>
                        <th><label htmlFor='addressLine3' translate='' key='address3'>{t[language].address3}</label></th>
                        <td><input type='text' maxLength='100' name='addressLine3' value={companydetail.addressLine3} onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''} /></td>
                      </tr>

                      <tr>
                        <th><label htmlFor='addressLine4' translate='' key='address4'>{t[language].address4}</label></th>
                        <td><input type='text' maxLength='100' name='addressLine4' value={companydetail.addressLine4} onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''} /></td>
                      </tr>

                      <tr>
                        <th className='req'><label htmlFor='city' >{t[language].city}</label></th>
                        <td><input type='text' maxLength='100' name='city' value={companydetail.city} onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''} /></td>
                      </tr>

                      <tr>
                        <th className='req'><label htmlFor='Country_ID' >{t[language].country}</label></th>
                        <td>
                          <select name='countryId' onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''}>
                            <CountryOptions countryList={this.props.countries} selectedCountryId={companydetail.countryId} />
                          </select>
                        </td>
                      </tr>

                      <tr id='US_Block'>
                        <th className='req'><label htmlFor='state' translate='' key='state'>{companydetail.countryId === '1' ? t[language].state : t[language].region}</label></th>
                        <td>
                          {
                            (this.props.regions != null && this.props.regions.length > 0)
                              ? <select name='state' className='companystate' selected={companydetail.state} onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''}>
                                <option selected='true' value='select'>{t[language].selstate}</option>
                                <Region regionList={this.props.regions} selectedvalue={companydetail.state} />
                              </select>
                              : <input type='text' maxLength='100' name='state' value={companydetail.state} onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''} />
                          }
                          <span className='companyInfo'>
                            <label className='req' htmlFor='zipcode' translate='' key='zip'>{t[language].zip}</label>
                            <input type='text' maxLength='100' name='zipcode' value={companydetail.zipcode} id='Foreign_Zip' onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''} />
                          </span>
                        </td>
                      </tr>
                      {(companydetail.companyType !== 'Distributor')
                        ? <tr>
                          <th><label htmlFor='Company_Distributor' translate='' key='distributor'>{t[language].distributor}</label></th>
                          <td>
                            <select name='distributorId' id='Company_Distributor' onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''}>
                              <option>{t[language].seldistributor}</option>
                              {distributorlist(this.props.distributors, companydetail.distributorId)}
                            </select>
                          </td>
                        </tr>
                        : <tr />
                      }
                      <tr>
                        <th className='req'><label htmlFor='phoneNumber' translate='' key='phone'>{t[language].phone}</label></th>
                        <td><input type='text' maxLength='100' name='phoneNumber' value={companydetail.phoneNumber} onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''} /></td>
                      </tr>

                      <tr>
                        <th><label htmlFor='faxNumber' translate='' key='fax'>{t[language].fax}</label></th>
                        <td><input type='text' maxLength='100' name='faxNumber' value={companydetail.faxNumber} onChange={this.handleChange} disabled={!companydetail.isOwner ? 'disabled' : ''} /></td>
                      </tr>

                      <tr className='saveBtn'>
                        <td />
                        <td> <button type='button' value='Save' onClick={this.handleSubmit} className={!companydetail.isOwner ? 'hide' : 'show'}>{t[language].save}</button></td>
                      </tr>
                    </tbody>
                  </table>
                </form>
              </div>
            </div>
          </section>
        </section>
      )
    }
  }
}

// Call Redux action and set the initial page state
function mapStateToProps (state) {
  return {
    companyDetails: state.company.companyDetails,
    countries: state.country.countries,
    regions: state.region.regions,
    distributors: state.distributor.distributors
  }
}

function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getCompanyDetail,
      getCountryList,
      getDistributorList,
      getRegionList
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(Company)



// WEBPACK FOOTER //
// ./src/components/Company/Company.js